Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iconCategories = require('../../utils/iconCategories');

var _makeIconWithDirectionMirroring = require('../../private/makeIconWithDirectionMirroring');

var _makeIconWithDirectionMirroring2 = _interopRequireDefault(_makeIconWithDirectionMirroring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ChevronRightSvg = function () {
  function ChevronRightSvg(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'm4.29 1.71a1 1 0 1 1 1.42-1.41l8 8a1 1 0 0 1 0 1.41l-8 8a1 1 0 1 1 -1.42-1.41l7.29-7.29z',
        fillRule: 'evenodd'
      })
    );
  }

  return ChevronRightSvg;
}();

ChevronRightSvg.componentCategory = 'Core';
ChevronRightSvg.displayName = 'ChevronRightSvg';
ChevronRightSvg.defaultProps = {
  viewBox: '0 0 18 18'
};


var IconChevronNext = (0, _makeIconWithDirectionMirroring2['default'])(ChevronRightSvg, 'IconChevronNext');
exports['default'] = IconChevronNext;


if (process.env.NODE_ENV !== 'production') {
  IconChevronNext.categories = [_iconCategories.DIRECTIONS];
}


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/icons/IconChevronNext.js
// module id = 148
// module chunks = 923280921217 19843951674672